'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'समय का चयन करें'
};

exports['default'] = locale;